import { useEffect } from 'react';

import { loadScript, scriptAlreadyLoaded } from '../script';

interface UseFacebookPixelProps {
  pixelID?: string;
  loadAfterLoadEvent?: boolean;
}
const SCRIPT_ID = 'facebook-pixel';

/**
 * Load facebook pixel script
 * (if already did, then do nothing)
 * to replace `FacebookPixelScript`
 * Notice: this will push the script loading later
 */
export const useFacebookPixel = (props?: UseFacebookPixelProps) => {
  const { pixelID = process.env.NEXT_PUBLIC_FB_PIXEL_ID, loadAfterLoadEvent } = props || {};
  useEffect(() => {
    if (pixelID && !scriptAlreadyLoaded(SCRIPT_ID)) {
      // from original script
      let fbq;
      if (!window.fbq) {
        fbq = window.fbq = function () {
          // eslint-disable-next-line
          fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
        };
        if (!window._fbq) window._fbq = fbq;
        fbq.push = fbq;
        fbq.loaded = !0;
        fbq.version = '2.0';
        fbq.queue = [];
      }

      if (window.fbq) {
        window.fbq('init', pixelID);
      }
      window.fbPixelID = pixelID;

      const loadFacebookPixel = () => loadScript('https://connect.facebook.net/en_US/fbevents.js', SCRIPT_ID);
      if (loadAfterLoadEvent) {
        window.addEventListener('load', loadFacebookPixel);
        return () => {
          window.removeEventListener('load', loadFacebookPixel);
        };
      }
      loadFacebookPixel();
    }
    // Only run once after loaded
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
